export default function makeStoreFields(options, storageKey, plus = {}) {
  const keys = Object.keys(options);


  //generation des getters/setters
  const getters = plus.getters || {};
  const mutations = {};
  const state = {};

  var values = options;
  if (storageKey != null) {
    try {
      const read = JSON.parse(localStorage.getItem(storageKey));
      if (read) {
        values = read;
      }
    } catch (e) {
      //noop
    }
  }

  for (const name of keys) {
    state[name] = values[name] || options[name];
    getters[name] = st => st[name];
    mutations[name] = (st, value) => {
      st[name] = value;

      if (storageKey) {
        localStorage.setItem(storageKey, JSON.stringify(st));
      }
    };
  }

  return {
    namespaced: true,
    state,
    mutations,
    getters,
  };
}
